import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //   const order = location.state?.order;
  //   console.log(order);
  return (
    <>
      <Navbar />

      <div className="h-[60vh] bg-white w-full py-[1rem]  px-[1rem] sm:px-[5rem] text-[16px] text-gray-500 flex items-center justify-center">
        <div className="w-[500px] py-10 px-6 bg-[#f5f5f5] flex flex-col items-center justify-center gap-3 rounded-2xl shadow-lg text-center">
          <IoCheckmarkCircleOutline size={70} color="#4CAF50" />

          <h2 className="text-[1.1rem] text-gray-600 font-semibold capitalize">
            Hey Customer
          </h2>

          <h1 className="text-[1.5rem] text-gray-800 font-bold">
            Your Order is Confirmed!
          </h1>

          <p className="text-[1rem] text-gray-600 leading-relaxed max-w-[380px]">
            We'll send you a shipping confirmation email as soon as your order
            ships.
          </p>

          <button
            onClick={() => navigate("/")}
            className="mt-4 rounded-lg px-6 py-2 text-[1rem] cursor-pointer bg-green-500 text-white hover:bg-green-600 transition"
          >
            Continue Shopping
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Success;
